import { render, staticRenderFns } from "./SupplierInquiryRequestButton.vue?vue&type=template&id=4f875600"
import script from "./SupplierInquiryRequestButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupplierInquiryRequestButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports